import { meFixtures, type MeFixture } from '@citibox-panel/api-client';

// Dev-only URL controls for mock mode. Parsing never touches the network; the caller decides
// whether to read the URL at all, and does so only when the mock API is on.
export const MOCK_REFUSE_PARAM = 'mockRefuse';
export const MOCK_ME_AFTER_PARAM = 'mockMeAfter';

export interface MockControls {
  // Mocked calls that answer a Rechazo por permiso; 'all' for every app-service call.
  refuse: readonly string[] | 'all' | null;
  // What /me answers from its second read on: another fixture, or a failure.
  meAfterFirstRead: MeFixture | 'error' | null;
}

export const INERT_MOCK_CONTROLS: MockControls = { refuse: null, meAfterFirstRead: null };

const isMeFixture = (value: string): value is MeFixture =>
  Object.prototype.hasOwnProperty.call(meFixtures, value);

export function readMockControls(search: string): MockControls {
  const params = new URLSearchParams(search);
  const rawRefuse = params.get(MOCK_REFUSE_PARAM)?.trim() ?? '';
  const refuse =
    rawRefuse === ''
      ? null
      : rawRefuse === '*'
        ? 'all'
        : rawRefuse
            .split(',')
            .map((call) => call.trim())
            .filter((call) => call !== '');
  const rawMe = params.get(MOCK_ME_AFTER_PARAM);
  // An unknown fixture name arms nothing rather than falling back to a guess.
  const meAfterFirstRead =
    rawMe === 'error' ? 'error' : rawMe !== null && isMeFixture(rawMe) ? rawMe : null;
  return { refuse, meAfterFirstRead };
}
